/* eslint-disable */

// Exclude smhc-ui if it is a ROBOTNIK build
require('./styles/honeycomb.scss');